import React from 'react';
import { connect } from 'react-redux';
import '../../css/spinner/spinner.css';

const spinnerUrl = '/assets/images/spinners/spinner.gif';

const Spinner = ({ show }) => {
  const showClass = show ? 'show' : '';
  return (
    <div className={`spinner-container ${showClass}`}>
      <div className="spinner-container__img-wrapper">
        <img
          src={spinnerUrl}
          alt="spinner"
          className="spinner-container__img"
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const show = state.ui.showSpinner;
  return {
    show,
  };
};

export default connect(mapStateToProps)(Spinner);



// WEBPACK FOOTER //
// ./src/components/UI/Spinner.js